/*
 * @Author: zhb 1822394027@qq.com
 * @Date: 2022-10-05 11:36:56
 * @LastEditors: zhb 1822394027@qq.com
 * @LastEditTime: 2022-10-06 17:41:32
 * @FilePath: \huayue\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';
import { constantRouterMap } from './menu';

// hack router push callback
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject); }
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const createRouter = () => new Router({
  mode: 'history',
  routes: constantRouterMap,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0, };
  },
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
